/** Volto Project Configuration
 * The recommended way for configuring a Volto project is using an add-on.
 * The project should only be considered as boilerplate, and all the code and
 * configuration should happen and be placed in add-ons.
 *
 * Both configuring directly and placing code in a project is discouraged, and might be
 * removed at some point from Volto.
 *
 * The local project is left for backwards compatibility for existing projects.
 */

// [Internal] All the imports of modules required for the configuration *must* happen
// here BEFORE the following line
import {
  MainSliderEditBlock,
  MainSliderViewBlock,
} from 'addons/volto-frontend/src/components/Blocks';

import sliderSVG from '@plone/volto/icons/slider.svg';

import '@plone/volto/config';

export default function applyConfig(config) {
  config.blocks.blocksConfig.mainSliderBlock = {
    id: 'mainSliderBlock',
    title: 'Main Slider Block',
    icon: sliderSVG,
    group: 'common',
    view: MainSliderViewBlock,
    edit: MainSliderEditBlock,
    restricted: false,
    mostUsed: false,
    security: {
      addPermission: [],
      view: [],
    },
  };

  return config;
}
